import { useState } from 'react';
import { Combobox, FluentProvider, Option } from '@fluentui/react-components';
import { useActiveTheme } from '../../theme/ThemeContext';
import { suggestionMatches } from './suggestionMatches';

interface SuggestionInputProps {
  id: string;
  value: string;
  suggestions: string[];
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
  disabled?: boolean;
}

export const SuggestionInput = ({
  id,
  value,
  suggestions,
  onChange,
  placeholder,
  maxLength,
  disabled,
}: SuggestionInputProps) => {
  const theme = useActiveTheme();
  const [isOpen, setIsOpen] = useState(false);
  const matches = suggestionMatches(suggestions, value);

  return (
    <FluentProvider theme={theme} style={{ width: '100%' }}>
      <Combobox
        freeform
        id={id}
        style={{ minWidth: 'auto', width: '100%' }}
        autoComplete="nope"
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        open={isOpen && matches.length > 0}
        onOpenChange={(_, data) => setIsOpen(data.open)}
        onChange={(event) => onChange(event.target.value)}
        onOptionSelect={(_, data) => {
          if (data.optionText !== undefined) onChange(data.optionText);
        }}
        input={{ maxLength }}
      >
        {matches.map((match) => (
          <Option key={match} value={match}>
            {match}
          </Option>
        ))}
      </Combobox>
    </FluentProvider>
  );
};
